import isMobile from "is-mobile";
import { mainGame } from "./main-game";

if (isMobile()) {
  mainGame()
} else {
  document.body.innerHTML = `<div class="use-mobile-tip">请使用手机打开</div>`
}